

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
@Component
export default class RechargeInfo extends Vue {
    @Prop({ default: 1 })
    private showGuide!: number;
    @Prop({ default: 0 })
    private money!: number;
    private banksInfo: any = [
        { id: 1, ownerName: 'Tạ Hoàng Tùng', bankNumber: '9581261318', branchName: 'MBbank' },
        { id: 2, ownerName: 'Tạ Hoàng Tùng', bankNumber: '108881261318', branchName: 'Vietinbank' }
    ];
    private bankSelected = this.banksInfo.find(x => x.id === 2);

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get currentTime() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = String(now.getFullYear()).slice(-2); // Get last two digits of the year
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return `${day}${month}${year}${hours}${minutes}`; // Format: DDMMYYHHmm
    }

    get qrLink() {
        return `https://api.vietqr.io/image/${this.bankSelected.branchName}-${this.bankSelected.bankNumber}-SUKDJlE.jpg?addInfo=HPO${this.userInfo.userId} ${this.currentTime}&accountName=${this.bankSelected.ownerName}&amount=${this.money}`;
    }

    private async onSelectBank(bankId: number) {
        this.bankSelected = this.banksInfo.find(x => x.id === bankId);
    }
}

